// HTTP client for the kiosk PWA.
// Uses the opaque device token from storage; routes use the same /api/v1.0 base as the
// admin frontend (configured by BACKEND_API_URL).

import { config } from './config.js';
import { getDeviceToken } from './storage.js';

class HttpError extends Error {
  constructor(message, status, body) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

async function request(method, path, body, { withAuth = true, timeoutMs = 15_000 } = {}) {
  const url = `${config.apiUrl}${path}`;
  const headers = { 'Content-Type': 'application/json' };
  if (withAuth) {
    const token = getDeviceToken();
    if (token) headers['Authorization'] = `Device ${token}`;
  }

  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      method,
      headers,
      body: body == null ? undefined : JSON.stringify(body),
      signal: controller.signal,
      mode: 'cors'
    });
    let parsed = null;
    try { parsed = await res.json(); } catch { /* non-JSON */ }
    if (!res.ok) {
      throw new HttpError(parsed?.message || `HTTP ${res.status}`, res.status, parsed);
    }
    return parsed;
  } finally {
    clearTimeout(t);
  }
}

// ---------- Public API ----------

export const api = {
  enroll: (payload) => request('POST', '/devices/enroll', payload, { withAuth: false }),
  heartbeat: (payload) => request('POST', '/devices/heartbeat', payload),
  sync: () => request('GET', '/devices/sync', null),
  lookup: (identification) => request('GET', `/devices/employees/by-id/${encodeURIComponent(identification)}`, null),
  marksBatch: (payload) => request('POST', '/devices/marks/batch', payload)
};

export { HttpError };
